module.exports = __webpack_public_path__ + "media/assets/fonts/D-DIN-Regular-f35fc7de7f81e0ad6c01558b64c59301.woff";